import { render, staticRenderFns } from "./foods.table.vue?vue&type=template&id=73dccc34&scoped=true&"
import script from "./foods.table.vue?vue&type=script&lang=js&"
export * from "./foods.table.vue?vue&type=script&lang=js&"
import style0 from "./foods.table.vue?vue&type=style&index=0&id=73dccc34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73dccc34",
  null
  
)

export default component.exports